module.exports = __webpack_public_path__ + "static/media/121-tool.4bf571b6.svg";